(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .directive('propriedadeMap', PropriedadeMap);

  function PropriedadeMap() {
    return {
      restrict: 'E',
      controller: 'PropriedadeMapCtrl',
      controllerAs: 'map',
      templateUrl: 'views/propriedade/propriedade-map.html',
      require: '^PropriedadeCtrl',
      scope: {
        culturasPorGleba: '<',
        customGlebaPolygonOptions: '<',
        legendas: '<',
        focusedGleba: '<',
        markers: '<',
        polylines: '<',
        additionalPolygons: '<polygons',
        imageOverlays: '<',
        activeHeatmaps: '<',
        headMapType: '<',
        defaultPolygons: '<',
        singleImageOverlay: '<'
      }
    };
  }
}());
